import { render, staticRenderFns } from "./BaseProblem.vue?vue&type=template&id=6af8616f&scoped=true"
import script from "./BaseProblem.vue?vue&type=script&lang=js"
export * from "./BaseProblem.vue?vue&type=script&lang=js"
import style0 from "./BaseProblem.vue?vue&type=style&index=0&id=6af8616f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8616f",
  null
  
)

export default component.exports